export const fileMoveTo = {
  title: '移动到',
  loading: '加载中',
  notSelectDirectory: '未选择文件夹',
  moving: '移动中',
  cancel: '取消',
  ok: '确定'
}
